import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {optionFilter} from "../../../utils/filters";
import {remoteOptionFormatter} from "../../../utils/formatters";

class TillList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "TillRepositoryList"}
                {...props}
                columns={{
                    "till.displayname": {
                        header: 'Eladási pont',
                        width: 6,
                        sortable,
                        filterable
                    },
                    "moneyrepository.name": {
                        header: 'Pénztár',
                        width: 6,
                        sortable,
                        filterable
                    },
                    "paymentmethod": {
                        header: 'Fizetés módja',
                        width: 6,
                        sortable,
                        filterable: optionFilter("paymentprovider"),
                        renderer: remoteOptionFormatter("paymentprovider")
                    },
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default TillList;
